export default __webpack_public_path__ + "static/media/drinking.8cfedbc2.png";